import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

import router from './router/router'; // Importera routern

const app = createApp(App);

// Chrome/Edge: keep the install prompt for our own "Installera" button (fired early, so caught first)
import { captureInstallPrompt } from '@/helpers/installprompt';
captureInstallPrompt();
const pinia = createPinia()

// project setup
import {inithelpers} from "./helpers";
inithelpers(app);
// the Material look's typeface, served with the app (works offline): one file per weight, which every Safari draws
// (the variable font fell back to its thinnest), the Latin letters only (å, ä and ö included)
import '@fontsource/nunito/latin-400.css';
import '@fontsource/nunito/latin-600.css';
import '@fontsource/nunito/latin-700.css';
import '@fontsource/nunito/latin-800.css';
import './style/main.scss'; // Import your custom Bootstrap styles

// setup based on settings
import settings from '@/settings/settings';

// languages
import { useTranslationsStore } from '@/dod/store/dtranslations';
const translationsStore = useTranslationsStore(pinia); // Use the globally registered store
translationsStore.languages = settings.default.languages;
translationsStore.translationFiles = settings.default.translations;

import { useWebSocketStore } from '@/dod/store/dwebsocket';
const wsStore = useWebSocketStore(pinia);
wsStore.keepid = settings?.default?.keep_websocketid ?? true;

// always setup dod
import {initdod} from "./dod/dimport";
initdod(app, pinia);

app.use(pinia)
app.use(router) // Använd routern   
app.mount("#app")

// PWA: offline app shell + Web Push (public/service-worker.js)
import { registerServiceWorker } from '@/helpers/serviceworker';
registerServiceWorker(router);

// sounds: taps anywhere in the app (also before the first game is opened) count as the tap iOS wants before a
// sound may play without one, e.g. "your turn" when another player's move arrives
import '@/helpers/sound';